export default __webpack_public_path__ + "static/media/login-bg-2.a9fe988f.jpg";